export const locale_int = function(value: any) {
	try {
		return value.toLocaleString('ru-RU', {maximumFractionDigits :0})
	} catch (error) {
		return '-'
	}
}

export const locale_float = function(value: any) {
	try {
		return value.toLocaleString('ru-RU', {maximumFractionDigits :2})
	} catch (error) {
		return '-'
	}
}

export const display_short = function(value: any, length: number) {
	try {
		if (value.length > length) {
			const start = value.slice(0, Math.ceil(length / 2))
			const end = value.slice(-Math.floor(length / 2))
			return `${start}...${end}`
		}
		return value
	} catch (error) {
		return value
	}
}

// Ссылка на телеграм-аккаунт (поддержка и т.п.).
//
// Открываем через openLink, а НЕ через openTelegramLink, хотя ссылка и
// телеграмовская. Причина в реализации SDK: openTelegramLink отправляет
// клиенту событие web_app_open_tg_link только когда мини-апп запущен в
// iframe (Telegram Web); в нативном вебвью он делает
// location.href = 'https://t.me/...', и если клиент эту навигацию не
// перехватывает, кнопка молча ничего не делает — без исключения, так что
// try/catch бесполезен. openLink же всегда уходит клиенту как
// web_app_open_link, и t.me-ссылки он открывает сам.
//
// Значение приходит из project_config и правится руками, поэтому заодно
// нормализуем частые написания: @name, name, t.me/name.
export function tma_open_tg_link(link: string) {
	const value = (link || '').trim()

	if (!value) {
		console.warn('tma_open_tg_link: пустая ссылка, открывать нечего')
		return
	}

	let url = value

	if (value.startsWith('@')) {
		url = `https://t.me/${value.slice(1)}`
	} else if (!/^https?:\/\//i.test(value)) {
		const path = value.replace(/^\/+/, '')
		url = /^(t|telegram)\.me\//i.test(path) ? `https://${path}` : `https://t.me/${path}`
	}

	const webapp = window.Telegram?.WebApp

	// Вне Telegram (браузер, дев-стенд) WebApp может не быть вовсе
	if (!webapp) {
		window.open(url, '_blank')
		return
	}

	webapp.openLink(url)
}

export function tma_open_link(link: string) {
	window.Telegram.WebApp.openLink(link)
}